import React from 'react';
import { Tag, Typography } from 'antd';
import { PLATFORM_LABEL, REGION_LABEL } from './materialConfig';

const { Text } = Typography;

// 展示「平台 + 上架区域」关联配置，如：Android 国内、海外 / iOS 国内
const TargetTags = ({ targets }) => {
    if (!targets?.length) return <Text type="secondary">-</Text>;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {targets.map((t) => {
                const regions = Array.isArray(t.regions) ? t.regions : (t.regions ? [t.regions] : []);
                return (
                    <div key={t.platform}>
                        <Tag color="blue" style={{ border: 'none' }}>{PLATFORM_LABEL[t.platform] || t.platform}</Tag>
                        <Text style={{ fontSize: 12 }}>
                            {regions.map((r) => REGION_LABEL[r] || r).join('、') || '-'}
                        </Text>
                    </div>
                );
            })}
        </div>
    );
};

export default TargetTags;
